import './Tab10.css';
import Information from '../Information/Information';
import de1 from '../../video/de1.mov';
import de2 from '../../video/de2.mov';
import de3 from '../../video/de3.mov';
import de4 from '../../video/de4.mov';
import de5 from '../../video/de5.mov';
import dudinskayaPhoto from '../../images/EN.jpeg';

function Tab10(props) {
  function handleDisplayClick() {
      props.onShow()
  }

  function handleTextClick() {
      props.onShowed()
  }

  function handleText2Click() {
      props.onShowed2()
  }

  function handleText3Click() {
      props.onShowed3()
  }

  function handleText4Click() {
      props.onShowed4()
  }

  return (
      <section className='tab10'>
          <Information
              title='Остеопороз после лечения'
              onClose = {props.onCloseText}
          >
              <p className='tab10__block-title'>Смотрим Дудинскую Екатерину Наильевну:</p>
              <div className='tab10__block'>
                  <div className='tab10__container'>
                      <img className='tab10__img' src={dudinskayaPhoto} alt='фотография Дудинской' />
                      <video className="tab10__video" src={de1} controls />
                      <p className='tab10__video-description' onClick={handleDisplayClick}>Немного о себе рассказывает Дудинская Екатерина Наильевна</p>
                      <div className={`${props.isOpen ? 'tab10__video-textBlock tab10__video-textBlock_opened' : 'tab10__video-textBlock'}`}>
                          <p className='tab10__video-text'>
                              "Здравствуйте дорогие друзья, меня зовут Екатерина Дудинская, я врач 
                              эндокринолог врач геронтолог. Работаю я в Российском Геронтологическом 
                              Научно-Клиническом центре. И основной, можно сказать, так почти основной 
                              задачей моей практической деятельности является ведение пациентов с 
                              остеопорозом. Конечно в большей степени это пациенты пожилого и старческого 
                              возраста. Я работаю геронтологическом центре, но так уж сложилось что 
                              остеопороз может коснуться любого человека, будь то ребёнок, подросток, 
                              молодой человек, молодая женщина, и волею судеб оказалось, что проблема, 
                              связанная с ранней менопаузой, гипогонадизмом, остеопорозом следствие химии 
                              лучевой терапии, это тоже является одним из направлений моей деятельности."
                          </p>
                      </div>
                  </div>
                  <div className='tab10__container'>
                      <img className='tab10__img' src={dudinskayaPhoto} alt='фотография Дудинской' />
                      <video className="tab10__video" src={de2} controls />
                      <p className='tab10__video-description' onClick={handleTextClick}>Остеопороз после ХТЛ</p>
                      <div className={`${props.isOpened ? 'tab10__video-textBlock tab10__video-textBlock_opened' : 'tab10__video-textBlock'}`}>
                          <p className='tab10__video-textTitle'>
                              Екатерина Наильевна, остеопороз после ХТЛ может выявиться только у женщин или у мужчин тоже?
                          </p>
                          <p className='tab10__video-text'>
                              "Остеопороз хоть и называется постменапаузальным, но поражает в том числе и мужчин.
                               И дело в том, что у мужчин сам по себе остеопороз развивается в более старшем 
                               возрасте. Если у женщин это связано с менопаузой в основном 55-60 лет и старше, 
                               то мужчин остеопороз поражает обычно в возрасте 70 лет и старше, в более позднем 
                               возрасте. Но если по поводу, например, онкологического заболевания была проведена 
                               химио - лучевая терапия у мужчины, то у него тоже может возникнуть андропауза, то 
                               есть остановка репродуктивного цикла и возникновение гипоногогизма. А вот именно 
                               гаппигоногизм у кого бы он ни был, у мужчины либо у женщины и приводит к развитию 
                               остеопороза. Поэтому да, у мужчин остеопороз бывает после химиолучевой терапии."
                          </p>
                      </div>
                  </div>
                  <div className='tab10__container'>
                      <img className='tab10__img' src={dudinskayaPhoto} alt='фотография Дудинской' />
                      <video className="tab10__video" src={de3} controls />
                      <p className='tab10__video-description' onClick={handleText2Click}>К какому врачу обращаться</p>
                      <div className={`${props.isOpened2 ? 'tab10__video-textBlock tab10__video-textBlock_opened' : 'tab10__video-textBlock'}`}>
                          <p className='tab10__video-textTitle'>
                              К какому врачу обращаться по поводу остеопороза?
                          </p>
                          <p className='tab10__video-text'>
                              "Остеопорозом занимаются врачи различных специальностей. Это связано с тем, 
                              на фоне какого заболевания возникает остеопороз. Ведь остеопороз — это 
                              следствие какой-либо проблемы, например, остеопороз на фоне эндокринных 
                              заболеваний – дефицит витамина Д, высокий уровень кортизола, например, 
                              это та область, которую ведет эндокринолог. Остеопороз на фоне 
                              ревматологических заболеваний ведёт ревматолог в основном. 
                              Терапевт занимается проблемой остеопороза и врач гериатр. 
                              Врач гериатр — это врач для пожилых людей старше 60 лет. 
                              В принципе специалист по остеопорозу может быть абсолютно любой специальности,
                              он должен просто пройти специальное обучение, это его хобби, это отдельное 
                              его желание заниматься остеопорозом, изучать этот вопрос и таких специалистов 
                              на самом деле немного, но есть сайт Российской Ассоциации по остеопорозу РАПО, 
                              на котором есть раздел специальный для пациента и вот в этом разделе есть адреса и 
                              телефоны всех центров остеопороза, которые находятся в Российской Федерации. 
                              Это могут быть различные города, совершенно разные направления, врачи разных 
                              специальностей, эндокринологи, ревматологи, терапевты гериатры ведут таких пациентов, 
                              и вы можете обратиться к этому сайту и узнать где для вас ближайшие центр остеопороза. 
                              Один из центров, которые вы можете там найти это центр нашей клиники 
                              Российского Геронтологического Научно - Клинического Центра."
                          </p>
                      </div>
                  </div>
                  <div className='tab10__container'>
                      <img className='tab10__img' src={dudinskayaPhoto} alt='фотография Дудинской' />
                      <video className="tab10__video" src={de4} controls />
                      <p className='tab10__video-description' onClick={handleText3Click}>Коротко об остеопорозе, как следствии химио-лучевой терапии</p>
                      <div className={`${props.isOpened3 ? 'tab10__video-textBlock tab10__video-textBlock_opened' : 'tab10__video-textBlock'}`}>
                          <p className='tab10__video-textTitle'>
                              Екатерина Наильевна, расскажите коротко об остеопорозе, как следствии химио-лучевой терапии, и о посменопаузальном остеопорозе?
                          </p>
                          <p className='tab10__video-text'>
                              "Самый распространённый вид остеопороза это остеопороз постменапаузальный и в основном он поражает 
                              женщин которые вступили в менопаузу 50, 55, 60 лет и старше. Но иногда бывает так что, менопауза 
                              возникает довольно рано, ранняя или преждевременная менопауза может поражать женщину в более молодом 
                              возрасте в самом расцвете сил. Иногда эта ранняя или преждевременная менопауза может быть связана с 
                              некоторыми онкологическими заболеваниями. Они напрямую не вызывают остеопороз, но процесс лечения, 
                              например, химио - лучевая терапия или оперативное лечение, когда удаляют яичники, например, вызывают 
                              раннюю менопаузу, останавливается репродуктивный цикл, и костная система начинает усиленно стареть. 
                              Повышается разрушение костной ткани, скорость производства увеличивается и развивается такой 
                              классический косвенно каузальный остеопороз, но в более молодом возрасте. 
                              Одной из проблемы химио - лучевой терапии как раз и является это раннее наступление менопаузы. 
                              Но ведение такого остеопороза оно никак не отличается от общих принципов ведения обычного привычного 
                              нам косвенно каузального остеопороза."
                          </p>
                      </div>
                  </div>
                  <div className='tab10__container'>
                      <img className='tab10__img' src={dudinskayaPhoto} alt='фотография Дудинской' />
                      <video className="tab10__video" src={de5} controls />
                      <p className='tab10__video-description' onClick={handleText4Click}>О необходимых профилактических анализах и исследованиях</p>
                      <div className={`${props.isOpened4 ? 'tab10__video-textBlock tab10__video-textBlock_opened' : 'tab10__video-textBlock'}`}>
                          <p className='tab10__video-textTitle'>
                              Расскажите, пожалуйста, о необходимых профилактических анализах и исследованиях и об их периодичности в случае ХЛТ в анамнезе и\или менопаузы.
                          </p>
                          <p className='tab10__video-text'>
                              "Проблема остеопороза заключается в том, что единственным его симптомом является наличие перелома. 
                              Перелома который происходит при минимальной травме. Чаще всего это падение с высоты собственного 
                              роста или ещё ниже. Допустим человек чихнул, кашлянул, неудачно повернулся в постели и случился 
                              перелом. Вот эти переломы, они характерны для остеопороза. Поэтому никаких более симптомов, 
                              которые могут насторожить человека чтобы он задумался о том какого его здоровье костей и к 
                              сожалению. Но если вдруг вы знаете о том, что у вас есть гипогонадизм, преждевременная ранняя 
                              менопауза у уже случившаяся менопауза, если у вас была химио - лучевая терапия, по поводу основного 
                              онкологического заболевания, то в принципе о здоровье костей тоже нужно задуматься. 
                              Для этого необходимо провести лабораторную и инструментальные диагностики. 
                              Золотой стандарт - это проведение рентгеновской денситометрии поясничного отдела позвоночника и 
                              проксимального отдела бедренной кости, в двух отделах делается. Денситометрия есть в тех центрах, 
                              где есть рентгеновский денситометр. Считается что рентгеновский денситометр — это золотой стандарт, 
                              потому что очень часто мы можем видеть результаты компьютерной денситометрии, данные МРТ, 
                              по этим данным диагноз остеопороза или остео не выставляется. Для лабораторной диагностики 
                              необходимо обследование кальци – фосфорного обмена. Это анализы на уровень кальция, общего кальция, 
                              ионизированного альбумина, креатинина, обязательно посмотреть уровень глюкозы, гормоны щитовидной 
                              железы, ТТГ тиреотропного гормона. Достаточно посмотреть ещё уровень фосфора и щелочной фосфатазы. 
                              Вот по всем законам, по всем нашим клиническим рекомендациям этого достаточно для того чтобы 
                              определить возможные другие, другие более сложные причины остеопороза, например, геперпаротериоз, 
                              нарушения фосфорного обмена и т.д. И после этого, когда доктор получит результаты лабораторного 
                              обследования, инструментального обследования, выбирать метод лечения и тактику ведения остеопороза, 
                              но это происходит только совместно со специалистом по остеопорозу. И самостоятельного лечения 
                              пожалуйста не назначайте сами себе."
                          </p>
                      </div>
                  </div>
              </div>
              <div className='tab10__block'>
                  <p className='tab10__block-note'>
                      Не все вышеуказанные исследования и обследования проходят в рамках ОМС данный вопрос необходимо обсуждать со своим врачом.
                      Информация носит рекомендательный характер.
                  </p>
              </div>
          </Information>
      </section>
  )
}

export default Tab10;